import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ScrapedDataPage } from '@/components/ScrapedData/ScrapedDataPage'
import {
  scrapedDataSearchSchema,
  withoutScrapedSearchDefaults,
} from '@/components/ScrapedData/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. The schema and the default-pruning live beside the page. */
export const Route = createFileRoute('/_app/scraped-data/')({
  validateSearch: scrapedDataSearchSchema,
  component: ScrapedDataRoute,
})

function ScrapedDataRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <ScrapedDataPage
      search={search}
      onSearchChange={(next) =>
        // Changing what is shown, not going somewhere new: replace, and keep
        // the scroll where the reader is.
        void navigate(inPageSearch(withoutScrapedSearchDefaults, next))
      }
    />
  )
}
